<div class="my-3 my-md-5">
    <div class="container">
        <div class="page-header">
            <h1 class="page-title">
                Messages
            </h1>
            <button type="button" class="btn btn-success" (click)="getWhatAppMessagesLeadWise()" [disabled]="loading"><i class="fa fa-sync" [ngClass]="{'fa-spin':loading}"></i> Fetch Messages List</button>
        </div>

        <div class="row row-cards" >
              <div class="col-sm-12">
                  <div class='card p-0 table-responsive'>
                    <div class="col-sm-12">
                        <form [formGroup]="messageForm" (submit)="sendMessage()">
                            <div class="row">
                                <div class="col-sm-3 message_left_panel nopadding">
                                    <div class="col-sm-12 nopadding text-center tempdiv"><h3 class="temphead">Templates</h3>
                                    <ul class="tempUl">
                                        <li class="tempLi" (click)="sendTemplateMessage('en_dnp_new')">EN-DNP</li>
                                        <li class="tempLi" (click)="sendTemplateMessage('en_followup_new')">EN Followup</li>
                                        <li class="tempLi" (click)="sendTemplateMessage('en_insurancecard_new')">EN InsuranceCard</li>
                                        <li class="tempLi" (click)="sendTemplateMessage('en_report_new')">EN Report</li>
                                    </ul>
                                        
                                    </div>
                                </div>
                                <div class="col-sm-9">
                                    <div class="row righttoppanel">

                                        <div class="col-sm-12">
                                            <ul class="messageul">
                                                <li class="messageli" *ngFor="let msg of allmessages;let index = index;" [ngClass]="{'text-right':msg.user_id==userId}" >
                                                    
                                                        <span class="messagespan" *ngIf="msg.message_type==1 || message_type==4">
                                                            {{msg.message}}
                                                        </span>
                                                        <span *ngIf="msg.message_type==2">
                                                            <a href="{{msg.message}}" download="{{msg.message}}">
                                                                <img src="{{msg.message}}" width="50px">
                                                            </a>
                                                        </span>
                                                        <span *ngIf="msg.message_type==3">
                                                            <a href="{{msg.message}}" download="{{msg.message}}">
                                                                <img src="./assets/images/download_whatsapp.png" width="50px">
                                                            </a>
                                                        </span>
                                                        <span class="messagespan" *ngIf="msg.message_type==4">
                                                            {{msg.message}}
                                                        </span>
                                                    <br><span class="messagetime">{{msg.date_time*1000|date:'d MMM, yyyy hh:mm aa'}}&nbsp;<span *ngIf="msg.name" class="user_name">({{msg.name}})</span></span>
                                                    
                                                </li>
                                            </ul>
                                            
                                        </div>
                                    </div>
                                    <div class="row right_bottom_panel" style="margin-top: 5px;">
                                        <div class="col-sm-1 attached_div image-upload">
                                            <label for="file-input">
                                                <i class="fas fa-paperclip iconfile"></i>
                                            </label>
                                            <input id="file-input" type="file" formControlName="filepath" (change)="uploadFile($event)" />
                                          </div>
                                        <div class="col-sm-9">
                                            <div class="col-sm-12 nopadding">
                                                <textarea rows="3" *ngIf="messageForm.controls['type'].value=='1'" type="text" formControlName="message" class="form-control"></textarea>
                                                
                                               <input *ngIf="messageForm.controls['type'].value=='2'" type="text" formControlName="selectfileName" class="form-control" readonly/>
                                               
                                               <textarea rows="3" *ngIf="messageForm.controls['type'].value=='3'" type="text" formControlName="message" class="form-control" readonly></textarea>

                                            </div>
                                            <!-- <div *ngIf="submitted && f.message.errors" class="invalid-feedback">
                                                <div *ngIf="f.message.errors.required">Message is required</div>
                                            </div> -->
                                        </div>
                                        <div class="col-sm-2" >
                                           <button type="submit" [disabled]="loading" class="btn btn-primary sendbtn" ><i *ngIf="loading" class="fa fa-spin fa-spinner"></i> Send
                                            </button>
                                            <button type="button" [disabled]="loading" class="btn btn-primary sendbtn" (click)="clearMessage()"> Clear
                                            </button>
                                            
                                        </div>
                                        
                                    </div>
                                </div>
                            </div> 
                        </form>    
                    </div>
                    
                  </div>
              </div>
          </div>

    </div>
</div>

